<script>
import gql from "graphql-tag";
import { tournamentMatchEndedFragment } from "@/graphql/tournament";
import { DialogInputTypes } from "@/js/helper";
import BaseUpsertDialog from "./baseUpsertDialog.vue";
import { MatchTools, NA_VENUE } from "@/js/helper";

export default {
  name: "UpdateMatchDialog",
  extends: BaseUpsertDialog,
  props: { tournament: Object, match: Object },
  data: function() {
    return {
      name: { label: "Name" },
      description: { label: "Description" },
      startTime: { label: "Start time", type: DialogInputTypes.datetime },
      endTime: { label: "End time", type: DialogInputTypes.datetime },
      venueId: {
        label: "Venue for the match",
        value: NA_VENUE
      },
      firstCompetitorId: {
        label: "First competitor"
      },
      secondCompetitorId: {
        label: "Second competitor"
      },
      winnerId: { label: "Winner" },
      loserId: { label: "Loser" },
      scoreNotes: { label: "Score" },
      winnerPoints: { label: "Winner points", type: DialogInputTypes.number },
      loserPoints: { label: "Loser points", type: DialogInputTypes.number }
    };
  },
  computed: {
    dialogInputs: {
      get() {
        return [
          this.name,
          this.description,
          this.venueId,
          this.firstCompetitorId,
          this.secondCompetitorId,
          this.winnerId,
          this.loserId,
          this.scoreNotes,
          this.winnerPoints,
          this.loserPoints
        ];
      }
    },
    title: {
      get() {
        return `Edit match - ${this.match.name}`;
      }
    },
    instructions: {
      get() {
        return "Use this form to manual update the properties of the match.";
      }
    },
    entity: {
      get() {
        return this.match;
      }
    }
  },
  methods: {
    customCopyValues() {
      const compOptions = MatchTools.competitorOptions(this.tournament);

      this.venueId.value = this.match.venue && this.match.venue.id;
      this.venueId.options = MatchTools.venueOptions(this.tournament);

      this.firstCompetitorId.value =
        this.match.firstCompetitor && this.match.firstCompetitor.id;
      this.firstCompetitorId.options = compOptions;

      this.secondCompetitorId.value =
        this.match.secondCompetitor && this.match.secondCompetitor.id;
      this.secondCompetitorId.options = compOptions;

      this.winnerId.value = this.match.winner && this.match.winner.id;
      this.winnerId.options = compOptions;

      this.loserId.value = this.match.loser && this.match.loser.id;
      this.loserId.options = compOptions;

      this.scoreNotes.value = this.match.score && this.match.score.notes;
      this.winnerPoints.value =
        this.match.score && this.match.score.totalWinnerScore;
      this.loserPoints.value =
        this.match.score && this.match.score.totalLoserScore;
    },
    submit() {
      return this.$apollo
        .mutate({
          mutation: gql`
            mutation($tournamentId: ID!, $match: MatchInput!) {
              updateMatch(tournamentId: $tournamentId, match: $match) {
                ...TournamentMatchEnded
              }
            }
            ${tournamentMatchEndedFragment}
          `,
          variables: {
            tournamentId: this.tournament.id,
            match: {
              id: this.match.id,
              name: this.name.value,
              description: this.description.value,
              venueId:
                this.venueId.value === NA_VENUE
                  ? undefined
                  : this.venueId.value,
              firstCompetitorId: this.firstCompetitorId.value,
              secondCompetitorId: this.secondCompetitorId.value,
              winnerId: this.winnerId.value,
              loserId: this.loserId.value,
              score: {
                notes: this.scoreNotes.value,
                totalWinnerScore: this.winnerPoints.value,
                totalLoserScore: this.loserPoints.value
              }
            }
          }
        })
        .then(result => {
          //this.$root.$emit("updateTournament", this.tournament.id);
          this.$store.commit(
            "setNotification",
            `Match ${this.match.name} updated`
          );
        })
        .catch(err => {
          console.log(err);
          window.alert("Failed to update the match");
        });
    }
  }
};
</script>


// WEBPACK FOOTER //
// updateMatchDialog.vue?5e86b99e